import { useQsFilters } from "@dash/filters";

import { signalLevels, signalSubjectDocTypes } from "@megaron/docs-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { defaultSignalsFilters } from "./filterSignals";

export const signalsFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  searchText: Serializers.string,
  apps: Serializers.string.array(),
  signalTypes: Serializers.string.array(),
  subjectDocTypes: Serializers.stringOneOf(...signalSubjectDocTypes).array(),
  levels: Serializers.stringOneOf(...signalLevels).array(),
  sort: Serializers.object({
    field: Serializers.stringOneOf("createdAt", "name", "level", "app"),
    order: Serializers.stringOneOf("ASC", "DESC"),
  }).optional(),
});

export type AllSignalsFilterValues = SerializerValue<typeof signalsFiltersSerializer>;

export const defaultAllSignalsFilters: AllSignalsFilterValues = {
  page: 0,
  ...defaultSignalsFilters,
};

export const useAllSignalsFilters = () => {
  const { filters, setFilters } = useQsFilters(signalsFiltersSerializer, defaultAllSignalsFilters);

  return { filters, setFilters, defaultFilters: defaultAllSignalsFilters };
};
